/**
{item: 'c', selected: true} C/C++
{item: 'java', selected: true} Java
{item: 'cs', selected: true} C#
{item: 'js', selected: true} JavaScript
{item: 'python', selected: true} Python
{item: 'go', selected: true} Go
{item: 'kt', selected: true} Kotlin
*/

const convertWithScanOptionText = (item) => {
  let text;
  switch (true) {
  case item === 'binary':
    text = 'Binary';
    break;
  case item === 'source':
    text = 'Source';
    break;
  case item === 'c':
    text = 'C/C++';
    break;
  case item === 'java':
    text = 'Java';
    break;
  case item === 'cs':
    text = 'C#';
    break;
  case item === 'js':
    text = 'JavaScript';
    break;
  case item === 'python':
    text = 'Python';
    break;
  case item === 'go':
    text = 'Go';
    break;
  case item === 'kt':
    text = 'Kotlin';
    break;
  default:
    text = item;
  }
  return text;
};

const sortValueofAtoZ = (array) => {
  array.sort((a, b) => {
    if (a.item < b.item) {
      return -1;
    }
    if (a.item > b.item) {
      return 1;
    }
    return 0;
  });
  return array;
};

const EXPORT_TAB_VIEW = {
  CLARITY: 'clarity',
  SBOM: 'sbom',
};

export {
  convertWithScanOptionText,
  sortValueofAtoZ,
  EXPORT_TAB_VIEW
};
